export const PROJECT_STATUS_TYPE = {
  ACTIVE: "ACTIVE",
  COMPLETE: "COMPLETE",
  INACTIVE: "INACTIVE",
  PREDEVELOPMENT: "PREDEVELOPMENT",
  SOLD: "SOLD",
  TEST: "TEST",
  UNDER_CONTRACT: "UNDER_CONTRACT",
};
